// Deterministically map a YYYY-MM-DD date string to an index in [0, len).
// Used to pick the Question of the Day so that every client — web AND mobile —
// resolves the SAME question for a given day and it stays stable across reloads
// (no Math.random). This is the ONE shared implementation: both apps' dates.js
// re-export this, so the pick can never drift and corrupt the shared
// apps/{APP}/qotd/{date} doc. Ported verbatim from the byte-identical app copies.
export const getDeterministicIndexForDate = (dateStr, len) => {
  if (!dateStr || !len || len <= 0) return 0;
  let hash = 0;
  for (let i = 0; i < dateStr.length; i++) {
    hash = (hash * 31 + dateStr.charCodeAt(i)) | 0;
  }
  return Math.abs(hash) % len;
};
